import { render, staticRenderFns } from "./CmgCheckoutPaymentHeader.vue?vue&type=template&id=0f451e86&scoped=true&lang=pug"
import script from "./cmg-checkout-payment-header.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout-payment-header.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckoutPaymentHeader.vue?vue&type=style&index=0&id=0f451e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f451e86",
  null
  
)

export default component.exports